module.exports = __webpack_public_path__ + "img/list_Story_06.227ecdc1.jpeg";